export const enum SessionStorageKey {
  LatestPaxConfig = 'pax',
  IsCarTripPlannerUser = 'isCarTripPlannerUser',
}
